import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';

import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { LinkContainer } from 'react-router-bootstrap';
import UserContext from '../user/UserContext';
import { IconWrapper } from './IconWrapper';

export default function CreateOrderLink() {
    const { userDetails } = useContext(UserContext);

    return (
        <div className={'create-order-link'}>
            <LinkContainer to={'/order/create'}>
                <Button
                    variant={'primary'}
                    className={'btn-action-green'}
                    disabled={
                        !userDetails.currentFranchise ||
                        (userDetails.currentFranchise.onHold && !userDetails.currentFranchise.payOnOrder) ||
                        userDetails.currentFranchise.status === 'Closed'
                    }
                >
                    <IconWrapper icon={faPlusCircle} />
                    Create Order
                </Button>
            </LinkContainer>
        </div>
    );
}
